// extracted by mini-css-extract-plugin
module.exports = {"scroll":"styles_scroll__MqMr0"};